import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';

export default (currVer: JSONSchema7): JSONSchema7 => {
  const properties = currVer.properties as JSONSchema7Properties;

  properties['version'].default = 3;

  properties['utilizeHiddenComponents'] = {
    $id: `${currVer.$id}/utilizeHiddenComponents`,
    default: false,
    type: 'boolean'
  };

  properties['rules'] = {
    $id: `${currVer.$id}/rules`,
    type: 'array',
    minItems: 1,
    maxItems: 10,
    default: []
  };

  return {
    ...currVer,
    properties
  };
};
